import {
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
} from '@mui/material'

type CompletedDemoDialogProps = {
	onClose: () => void
	onConfirm: () => void
}

export const CompletedDemoDialog = (props: CompletedDemoDialogProps) => {
	return (
		<>
			<DialogTitle>Demo Complete</DialogTitle>
			<DialogContent>
				Thank you for trying out the {globalThis.appSettings.APP_NAME} optical
				character recognition demo! If you'd like to return to your document,
				click "Go Back". If you'd like to try again, click "Complete".
			</DialogContent>
			<DialogActions>
				<Button onClick={props.onClose} variant="outlined">
					Go Back
				</Button>
				<Button onClick={props.onConfirm} variant="contained">
					Complete
				</Button>
			</DialogActions>
		</>
	)
}
